module.exports = __webpack_public_path__ + "img/kv_1_2.8ac78fe2.png";